import { useEffect, useState } from "react";
import { Advertising as AdvertisingType } from "../helpers/interfaces";
import { apiGet } from "../services/Api";
import { HTMLElement } from "./HTMLElement";
import DOMPurify from "dompurify";

declare global {
    interface Window {
        adsbygoogle: any[];
    }
}

type Props = {
    code: string,
    as?: React.ElementType,
    type?: "banner"|"background",
    [x: string]: any
};

export default function Advertising(props: Props) {
    const [isMount, setIsMount] = useState<boolean>(false);
    const [advertising, setAdvertising] = useState<JSX.Element|null>(null);
    const {code, as = "div", type="banner"} = props;
    const As = as;
    const config: DOMPurify.Config = {
        ADD_TAGS: ["iframe"],
        ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'target']
    }

    const rest: { [x: string]: any } = { ...props };
    delete rest.as
    delete rest.code

    useEffect(() => {
        (async() => {
            if (!isMount) {
              setAdvertising(await apiGet<AdvertisingType, any>(
                '?op=banner&id=' + code
            ).then(
                (response: AdvertisingType) => {
                    return <HTMLElement
                        id={`adv-${code}`}
                        as={As}
                        className={type === "banner" ? "text-center py-4" : ""}
                        html={response ?? ''}
                        config={config}
                        {...rest}
                    />
                }
            ).catch((e) => {
                return <HTMLElement id={`adv-${code}`} as={As} html={''} {...rest} />
            }));

            setIsMount(true);
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (!advertising) return;

        const adEl = document.querySelector(`#adv-${code} .adsbygoogle`);
        if (adEl) {
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (e) {
                console.error("Google Ads error:", e);
            }
        }
    }, [advertising, code]);


    return advertising;
}
